var settings = {
  authorization: {
    loggedIn: false,
    state: {},
    data: {}
  },
  show: {
    unreleased: `${process.env.BASE_IS_UNRELEASED}` === 'yes',
    alert: {
      active: false,
      type: 'info',
      message: '',
      timer: null
    }
  }
}

export default settings



// WEBPACK FOOTER //
// ./src/assets/global-settings.js